var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c(
        "div",
        {
          staticClass: "siderbar-wrapper",
          class: { "siderbar-wrapper-collapsed": _vm.isCollapsed },
        },
        [
          _c(
            "el-menu",
            {
              staticClass: "menu-wrapper",
              attrs: {
                "text-color": "#2F3030",
                "active-text-color": "#00B498",
                router: "",
                "unique-opened": "",
                collapse: _vm.isCollapsed,
                "default-active": _vm.activeIndex,
              },
              on: { open: _vm.test, select: _vm.selectMenu },
            },
            [
              _vm._l(_vm.visibleMenuData, function (item, index) {
                return [
                  item.jumpUrl == "@LINK"
                    ? _c(
                        "li",
                        {
                          staticClass: "el-menu-item menu-itemFix1",
                          staticStyle: { "padding-left": "20px" },
                        },
                        [
                          _c(
                            "p",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.toLink(item)
                                },
                              },
                            },
                            [
                              _c("el-image", {
                                staticClass: "imgSize img-default",
                                attrs: { src: item.iconUrl, alt: "" },
                              }),
                              _c("el-image", {
                                staticClass: "imgSize img-hover",
                                attrs: { src: item.onHoverIconUrl, alt: "" },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "menu-name",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : item.jumpUrl !== "@LINK" && !item.children
                    ? _c(
                        "el-menu-item",
                        {
                          key: index,
                          staticClass: "menu-itemFix1",
                          attrs: { index: item.jumpUrl },
                        },
                        [
                          _c(
                            "p",
                            [
                              _c("el-image", {
                                staticClass: "imgSize img-default",
                                attrs: { src: item.iconUrl, alt: "" },
                              }),
                              _c("el-image", {
                                staticClass: "imgSize img-hover",
                                attrs: { src: item.onHoverIconUrl, alt: "" },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "menu-name",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _c(
                        "el-submenu",
                        {
                          staticClass: "menu-itemFix2",
                          attrs: { index: item.jumpUrl },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c(
                              "div",
                              { staticClass: "menu_second" },
                              [
                                _c("el-image", {
                                  staticClass: "imgSize img-default",
                                  attrs: { src: item.iconUrl, alt: "" },
                                }),
                                _c("el-image", {
                                  staticClass: "imgSize img-hover",
                                  attrs: { src: item.onHoverIconUrl, alt: "" },
                                }),
                                _c("span", { staticClass: "menu-name" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _vm._l(item.children, function (sub_item, sub_index) {
                            return _c(
                              "div",
                              { key: sub_index },
                              [
                                sub_item.jumpUrl == "@LINK"
                                  ? _c(
                                      "li",
                                      {
                                        staticClass:
                                          "el-menu-item menu-item menu-itemFix is-active",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "margin-left": "52px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toLink(sub_item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#2f3030",
                                                },
                                              },
                                              [_vm._v(_vm._s(sub_item.name))]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-menu-item",
                                      {
                                        staticClass: "menu-item menu-itemFix",
                                        attrs: { index: sub_item.jumpUrl },
                                        on: {
                                          click: function ($event) {
                                            return _vm.test(sub_item, item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "margin-left": "52px",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(sub_item.name)),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "topbar-wrapper" }, [
        _vm._m(0),
        _c("div", { staticClass: "topbar-wrapper-right" }, [
          _c(
            "div",
            { staticClass: "btn" },
            _vm._l(_vm.btns, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: [
                    _vm.currentIndex == index ? "btn_item_active" : "btn_item",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.selectSystem(index)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.name) + " ")]
              )
            }),
            0
          ),
          !_vm.is_null(_vm.personInfo)
            ? _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.personInfo.reallyName)),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.personInfo)
            ? _c("div", { staticClass: "company" }, [
                _vm._v(_vm._s(_vm.personInfo.orgName)),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "notice",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.$router.push("/notice")
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../assets/img/notice/icon_tongzhi_16.png"),
                  alt: "",
                },
              }),
              _vm._v(" 通知 "),
              _vm.readCount.unread !== "undefined"
                ? _c("el-tag", { attrs: { "font-size": "18px", round: "" } }, [
                    _c("p", [_vm._v(_vm._s(_vm.readCount.unread))]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "setting" },
            [
              _c(
                "el-dropdown",
                {
                  on: {
                    command: function ($event) {
                      return _vm.command($event)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center",
                        cursor: "pointer",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-setting" }),
                      _c("div", { staticClass: "setting-t" }, [_vm._v("设置")]),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          staticClass: "custom-item",
                          attrs: { command: "password" },
                        },
                        [_vm._v("修改登录密码")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          staticClass: "custom-item",
                          attrs: { command: "info" },
                        },
                        [_vm._v("个人信息")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          staticClass: "custom-item",
                          attrs: { command: "logout" },
                        },
                        [_vm._v("退出")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "nav",
            style: { left: this.isCollapsed ? "96px" : "216px" },
          },
          [_c("tarbar")],
          1
        ),
      ]),
      _c("div", {
        staticClass: "toggle-menu",
        class: { "toggle-menu-collapsed": _vm.isCollapsed },
        on: { click: _vm.toggleMenu },
      }),
      _c(
        "div",
        {
          ref: "content-wrapper",
          staticClass: "content-wrapper",
          style: {
            left: this.isCollapsed ? "80px" : "200px",
            bottom: _vm.hasBottom ? "84px" : "0",
          },
          on: { scroll: _vm.handleScroll },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  _c(
                    "keep-alive",
                    [
                      _vm.$route.meta.keepAlive
                        ? _c("router-view", {
                            key: _vm.$route.name,
                            attrs: { pageActive: _vm.pageActive },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  !_vm.$route.meta.keepAlive
                    ? _c("router-view", {
                        key: _vm.$route.name,
                        attrs: { pageActive: _vm.pageActive },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.isConfirm,
            width: "268px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isConfirm = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                color: "#2F3030",
                "line-height": "22px",
                "text-align": "center",
                "margin-left": "12px",
              },
            },
            [_vm._v(" 是否确认退出当前账号登录？")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isConfirm = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.logout } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改密码",
            visible: _vm.isPassword,
            width: "552px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isPassword = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-body" }, [
            _c(
              "div",
              { staticClass: "dialog-title" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "form",
                    staticStyle: { width: "100%" },
                    attrs: {
                      inline: true,
                      model: _vm.form,
                      size: "small",
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { label: "输入旧密码", prop: "oldPassword" },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "346px" },
                          attrs: {
                            placeholder: "请输入",
                            maxlength: "16",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.oldPassword,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "oldPassword", $$v)
                            },
                            expression: "form.oldPassword",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { label: "输入新密码", prop: "newPassword" },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "346px" },
                          attrs: {
                            placeholder: "请输入",
                            maxlength: "16",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.newPassword,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "newPassword", $$v)
                            },
                            expression: "form.newPassword",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: {
                          label: "重复新密码",
                          prop: "secondNewPassword",
                        },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "346px" },
                          attrs: {
                            placeholder: "请输入",
                            maxlength: "16",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.secondNewPassword,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "secondNewPassword", $$v)
                            },
                            expression: "form.secondNewPassword",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isPassword = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitPassword },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "topbar-wrapper-left" }, [
      _c("img", {
        staticStyle: { width: "112px", height: "32px" },
        attrs: { src: require("../../assets/title.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }